import React, { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import styles from '../styles/ptPremiumBanner.scss';
import ptPremiumLogo from '../../../assets/images/pt-premium-logo.svg';
import dismissIcon from '../../../assets/images/dismiss-icon.svg';
import { useSelector } from 'react-redux';
import { getIsSideNavigationCollapsed } from '../../../redux/actions/appActions';
import { PtSubscriptionModal } from './ptSubscriptionModal';
import { useTranslation } from 'react-i18next';

const LOCAL_STORAGE_KEY = 'ptPremiumBannerDismissed';

const PtPremiumModal: React.FC = () => {
  const [isBannerVisible, setIsBannerVisible] = useState(true);
  const [showPtSubscriptionModal, setShowPtSubscriptionModal] = useState(false);
  const isCollapsed = useSelector(getIsSideNavigationCollapsed);
  const location = useLocation();
  const { t } = useTranslation('common', { keyPrefix: 'proTransportSubscriptions' });

  // Always show on /loads routes
  const isLoadManagement = location.pathname.startsWith('/loads');

  useEffect(() => {
    if (isLoadManagement) {
      setIsBannerVisible(true);
    } else {
      const dismissed = localStorage.getItem(LOCAL_STORAGE_KEY);
      setIsBannerVisible(dismissed !== 'true');
    }
  }, [location.pathname]);

  const handleBannerClose = () => {
    setIsBannerVisible(false);
    localStorage.setItem(LOCAL_STORAGE_KEY, 'true');
  };

  const sideNavWidth = isCollapsed ? 70 : 160;

  return (
    <>
      {isBannerVisible && (
        <div
          className={styles.ptPremiumBanner}
          style={{
            left: sideNavWidth,
            width: `calc(100vw - ${sideNavWidth + 48}px)`,
          }}
        >
          <img src={ptPremiumLogo} alt="PT Premium Background Image" className={styles.backgroundImage} />
          <div className={styles.content}>
            <div className={styles.bannerText}>
              <strong>{t('unlock_the_power_of_protransport')}</strong> {t('access_pt_premium')}
            </div>
            <div className={styles.bannerActions}>
              <button className={styles.actionButton} onClick={() => setShowPtSubscriptionModal(true)}>
                {t('learn_more')} <strong>{t('or')}</strong> {t('subscribe')}
              </button>
              <div
                className={styles.closeButton}
                onClick={handleBannerClose}
                onKeyDown={handleBannerClose}
                role="button"
                tabIndex={0}
                aria-label="Close"
              >
                <img src={dismissIcon} alt="Dismiss" />
              </div>
            </div>
          </div>
        </div>
      )}
      <PtSubscriptionModal
        sideNavWidth={isCollapsed ? 70 : 160}
        open={showPtSubscriptionModal}
        onClose={() => setShowPtSubscriptionModal(false)}
      />
    </>
  );
};

export default PtPremiumModal;
